// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as MobilePhoneIphoneComponent} from './MobilePhoneIphone.svg';

import Icon, { TIconProps } from '../Icon';

export const IconMobilePhoneIphone = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <MobilePhoneIphoneComponent/>
  </Icon>
));
